import React from 'react';

interface Props {
  className?: string;
  color?: string;
}

export function PicoteDivider({ className = '', color = 'var(--ink-300)' }: Props) {
  return (
    <div
      aria-hidden="true"
      className={`w-full h-2 ${className}`}
      style={{
        backgroundImage: `radial-gradient(circle, ${color} 1.5px, transparent 1.5px)`,
        backgroundSize: '10px 8px',
        backgroundPosition: 'center',
        backgroundRepeat: 'repeat-x',
      }}
    />
  );
}
